var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvgSalaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4118 23H7.47059C3.58824 23 1 21.0588 1 16.5294V7.47059C1 2.94118 3.58824 1 7.47059 1H20.4118C24.2941 1 26.8824 2.94118 26.8824 7.47059V16.5294C26.8824 21.0588 24.2941 23 20.4118 23Z",
    stroke: "#5161CC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.937 15.8829C16.0813 15.8829 17.8194 14.1447 17.8194 12.0005C17.8194 9.85629 16.0813 8.11816 13.937 8.11816C11.7928 8.11816 10.0547 9.85629 10.0547 12.0005C10.0547 14.1447 11.7928 15.8829 13.937 15.8829Z",
    stroke: "#5161CC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.53125 8.76465V15.2352",
    stroke: "#5161CC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.3477 8.76465V15.2352",
    stroke: "#5161CC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgSalaryIcon);
export default __webpack_public_path__ + "static/media/avgSalaryIcon.41fa3b7606101b41b6a6f761e7c21944.svg";
export { ForwardRef as ReactComponent };